var SENTRY_RELEASE;SENTRY_RELEASE={name: "EventLive", version: "1.0.0"};